module.exports = __webpack_public_path__ + "static/media/girlMobile.df52ff5e.png";